import { render, staticRenderFns } from "./ChatMessageInput.vue?vue&type=template&id=9c2ba9ac&scoped=true&"
import script from "./ChatMessageInput.vue?vue&type=script&lang=js&"
export * from "./ChatMessageInput.vue?vue&type=script&lang=js&"
import style0 from "./ChatMessageInput.vue?vue&type=style&index=0&id=9c2ba9ac&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2ba9ac",
  null
  
)

export default component.exports